import React, { useState } from 'react'
import { Box, Button, FormControl, InputLabel, TextField, Typography } from '@mui/material'
// import logo from '../../assets/Project_Images/App_logo.png'
import email from '../../assets/Project_Images/Icons/email.png'
import { PersonOutline } from '@mui/icons-material'
import { Link, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from "yup"
import { useNavigate } from 'react-router-dom'
// import { ApiSendOtp } from '../../apiService/Core/Apicall'
import { ApiSendOtp } from '../../apiService/Core/Apicall'
import { useDispatch, useSelector } from 'react-redux'
import { Images } from '../../global/GloblImages'
import storage from '../../utils/storage'

interface FormValues {
    email: string;
}
const ForgotPassword: React.FC = () => {
    const dispatch = useDispatch()
    const navigation = useNavigate()
    const location = useLocation();
    const loading = useSelector((state: any) => state.loader.isLoading);
    const [showerror, setshowerror] = useState<boolean>(false);
    const { MMLogo } = Images()

    const initialValues: FormValues = {
        email: '',
    }
    const keyup = (e: any) => {
        if (e.code === "Enter") {
            formik.handleSubmit();
        }
    };


    const onSubmit = async (values: FormValues) => {
        const Apidata = {
            emailId: values.email,
            requestType:"forgot_password" 
        }
        try {
            const response: any = await ApiSendOtp(Apidata);
            if (response.status) {
                storage.setItem('auth', "otp");
                storage.setItem('emailId', values.email);
                navigation('/otp')
            }

        }
        catch (error) {
            alert(error)
        }
    }
    const validationSchema = Yup.object({
        email: Yup.string().email('Invalid email format').required("Enter your email"),

    });
    const formik = useFormik<FormValues>({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: false,
    })
    return (

        <Box className='d-flex flex-column  align-items-center'>
            <Box component='img' className='mb-2' width='50%' zIndex={2} src={MMLogo} height='auto' alt='logo' />

            <Box className='flex-grow-1 mt-5 ' position='relative'>
                <Typography className='text-main fs-3 fw-bold'>Reset Password</Typography>
                <Typography className='fs-18 '>Let’s Verify your Email ID to reset password.</Typography>
                <Box className='mt-5 input-border'>
                    <form onSubmit={formik.handleSubmit}>
                        <FormControl className='col-12'>
                            <label className='label'>Email ID <span className='text-danger'>*</span></label>
                            <TextField
                                className='custom-textfield'
                                sx={{"& fieldset":{border:"1px solid black !important"}}}
                                slotProps={{
                                    input: {
                                        startAdornment: <PersonOutline className='fs-2 text-main' />
                                    }
                                }}
                                InputLabelProps={{
                                    shrink: false,

                                }}
                                {...formik.getFieldProps("email")}
                            ></TextField>
                            {showerror && formik.errors.email ? (
                                <Typography className="error text-danger" variant='caption'>
                                    {formik.errors.email}
                                </Typography>
                            ) : null}
                        </FormControl>

                        <Typography className='d-block mt-4'>You will receive an OTP to verify your email</Typography>
                        <Button type='submit' onClick={() => setshowerror(true)} fullWidth className='button-primary py-2 mt-5'>Get OTP</Button>
                    </form>
                </Box>
            </Box>
        </Box>
    )
}

export default ForgotPassword
